import { Component, Input } from '@angular/core';

@Component({
  selector: 'bn-semaphore-tooltip',
  templateUrl: './bn-semaphore-tooltip.component.html',
})
export class BnSemaphoreTooltipComponent {
  @Input() type = '';
  @Input() text = '';
}
